module.exports = __webpack_public_path__ + "static/media/immunization.251b45cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/immunization.gif
// module id = 362
// module chunks = 0